<!-- 小程序跳转码数量统计 -->
<template>
<div>
	<!-- 标题 -->
	<div :style="{'width': table_scroll_width + 'px'}" style="position: relative;">
		<div class="page-title"  style="position: sticky;left: 30px;z-index: 5;width: 300px;">小程序跳转码数量统计</div>
		
		<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 10px 0 5px;position: sticky;left: 30px;z-index: 5;" :style="{'width': body_width + 'px'}">
			
			<div class="screen-box" >
				<div class="screen-label">投放日期</div>
				<a-date-picker @change="onChangeDate" :locale="locale"  :allowClear="false" :value="this.moment(endTime, dateFormat)" />
				<!-- <a-range-picker style="width:300px;" @change="onChangeDate" :allowClear="false"
				:locale="locale" 
				:value="[this.moment(startTime, dateFormat),this.moment(endTime, dateFormat)]" /> -->
			</div>
			
			<!-- <div class="screen-box" >
				<div class="screen-label">公众号</div>
				<a-select
					style="min-width: 200px"
					placeholder="请选择公众号"
					@change="handleChangeA"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
					showSearch
				  >
					<a-select-option v-for="(item,index) in filterData.gzh_id.list" :key="index" :value="item.key">
					  {{item.value}}
					</a-select-option>
					
				</a-select>
			</div> -->
			
			<div class="screen-box" >
				<div class="screen-label">小程序</div>
				<a-select
					style="min-width: 200px"
					placeholder="请选择小程序"
					@change="handleChangeC"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
					showSearch
				  >
					<a-select-option v-for="(item,index) in selectXcx" :key="index" :value="item.id">
					  {{item.name}}
					</a-select-option>
					
				</a-select>
			</div>
			
			<a-button @click="searchButton" :loading="search_button_loading" type="primary" icon="search" style="margin-right: 20px;">搜索</a-button>
			
		</div>
	</div>
	
	<!-- 表头 -->
	<div class="table-th" ref="table_th" :style="{'width': table_scroll_width + 'px'}">
		<div   class="table-th-cell-sticky" style="display: flex;align-items: center;">
			<div class="table-th-cell" style="cursor: default;" 
			:style="{'width':rableTitle[0].width + 'px'}" >
				小程序Id
				
			</div>
			<div class="table-th-cell" style="cursor: default;"
			:style="{'width':rableTitle[1].width + 'px'}" >
				小程序名称
			</div>
			
		</div>
		
		<div  v-for="(item,index) in rableTitle" :key="index" >
		
			<div v-if="index > 1" class="table-th-cell" 
			:style="{'width':item.width + 'px','cursor':item.sort_control?'pointer':'default','justify-content': item.text_right?'flex-end':''}"
			@click="sortClick(index)">
				{{item.title}}
				<div v-if="item.sort_control" style="display: flex;flex-direction: column;width: 12px;margin-left: 5px;">
					<a-icon type="caret-up" :style="{'color': item.sort_status === 2?'#1890ff':'#999'}" style="font-size: 12px;margin-bottom: -4px;" />
					<a-icon type="caret-down" :style="{'color': item.sort_status === 1?'#1890ff':'#999'}" style="font-size: 12px;" />
				</div>
			</div>
		</div>
		<!-- 占位，隔出一个空白区域 -->
		<div id="" style="padding:15px;"></div>
	</div>
	
	
	
	<!-- 表格内容 -->
	<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
		<div  class="table-td-cell-sticky" style="display: flex;align-items: center;">
			
				<div  class="table-td-cell"
				:style="{'width':rableTitle[0].width + 'px'}">
					{{item.id}}
				</div>
				<div  class="table-td-cell"
				:style="{'width':rableTitle[1].width + 'px'}">
					{{item.name}}
				</div>
			
		</div>
		
		<!-- 跳转码数量 -->
		<div class="table-td-cell" :style="{'width': rableTitle[2].width + 'px'}">
			{{item.count}}
		</div>
		<!-- 操作 -->
		<div class="table-td-cell" :style="{'width': rableTitle[3].width + 'px'}" style="display: flex;flex-wrap: wrap;">
			
			<div @click="editTable(item,1)" style="color: #62a8ea;cursor: pointer;margin-right: 11px;">查看使用详情</div>
			
			<div @click="editTable(item,2)" style="color: #62a8ea;cursor: pointer;">查看小程序详情</div>
		</div>
		
	</div>
	
	
	<div v-show="tableShowData.length === 0" style="text-align: center;margin: 80px 0 50px;" :style="{'width': table_null_width + 'px'}">
		<a-icon style="font-size: 70px;color: #999;" type="file-search" />
		
		<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
	</div>
	
	
	<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
	<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
	
	
	<!-- 分页 -->
	<div :style="{'width': table_scroll_width + 'px',}">
		<div style="text-align: center;margin-top: 30px;position: sticky;left: 30px;" :style="{'width': table_null_width + 'px',}">
			<a-pagination v-model="r_page" :pageSize="r_limit" :total="table_total" @change="paginationChange" />
		</div>
	</div>
	
	
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
	
import { xcxDataList,  bookInfo, opeGzhXcx, putDataMenu } from '@/request/api'
export default {
	name: 'xcxSchemeData_',
	components: {
	},
	data() {
		this.dateFormat = 'YYYY-MM-DD'
		return {
			locale,
			moment,
			startTime: '2020-05-01', // 投放日期-开始时间
			endTime: '2022-06-30', // 投放日期-结束时间
			
			
			r_limit: 50,
			r_page: 1,
			r_sort_field: "", // 要排序的字段
			r_sort_type: "", // 排序方式
			r_gzh_id: "", // 公众号
			r_applets_id: "", // 小程序
			
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"小程序Id",width:150, sort_status:0, type:"id", text_right: false,sort_:90,sort_control: false,}, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"小程序名称",width:230, sort_status:0, type:"name", text_right: false,sort_:89,sort_control: false,},
				{title:"跳转码数量",width:190, sort_status:0, type:"count", text_right: false,sort_:36,sort_control: false,},
				{title:"操作",width:230, sort_status:0, type:"cz", text_right: false,sort_:35,sort_control: false,},
				
			],
			tableShowData: [],
			table_scroll_width: 1600,
			body_width: 1600, // body的宽度
			table_null_width: 1500, // 表格内容为空时，空提示的宽度范围
			
			search_button_loading: false, // 搜索按钮的加载状态
			add_button_loading: false, // 新增侧边栏的确认按钮加载状态
			
			visible: false,
			// 新增侧边栏
			x_book_name: "", // 作品名称
			x_roi: "", // 首日ROI目标(%)
			x_book_type: undefined, // 频道
			x_category: undefined, // 分类
			x_id: "", // id
			add_form_hint: "", // 侧边栏新增表单的验证提示
			categoryManList: [], // 男频的分类选择
			categoryWomanList: [], // 女频的分类选择
			categoryShowList: [], // 分类的显示
			drawer_title: "", // 侧边栏标题
			table_total: 0, // 表格内容总数
			
			
			
			// 筛选条件部分
			filterData: {
				op_id:{
					list: [{}],
				},
				
				media_id:{
					list: [{}],
				},
				channel_id:{
					list: [{}],
				},
				gzh_id:{
					list: [{}],
				},
				
				
			}, // 筛选条件数组
			selectXcx: [], // 选择小程序
			r_applets_id: undefined, // 选择小程序
			r_gzh_id: undefined, // 选择公众号
			
		}
	},
	mounted(){
		let that = this
		
		// 获取当前日期
		let date2 = new Date();
		let month2
		if(date2.getMonth() + 1 < 10){
			month2 = '0' + (date2.getMonth() + 1)
		}
		else {
			month2 = date2.getMonth() + 1
		}
		let day2
		if(date2.getDate() < 10){
			day2 = "0" + date2.getDate()
		}
		else {
			day2 = date2.getDate()
		}
		that.endTime = date2.getFullYear() + "-" + month2 + "-" + day2;
		
		
		// 获取表格信息
		let table_info = this.$getTableInfo(that.rableTitle)
		that.body_width = table_info.body_width
		that.table_scroll_width = table_info.table_width
		that.table_null_width = table_info.null_width
		
		// putDataMenu().then(res=>{
		// 	console.log("获取搜索条件",res);
		// 	that.filterData = res.data.data.filter
		// })
		
		opeGzhXcx().then(res=>{
			console.log("获取小程序",res);
			that.selectXcx = res.data.data.applets
		})
		
		that.searchButton()
		
	},
	methods:{
		// 单个日期选择
		onChangeDate(date, dateString) {
			// console.log(date, dateString);
			
			this.endTime = dateString
		},
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		// 请选择公众号
		handleChangeA(e){
			console.log(e);
			this.r_gzh_id = e
		},
		handleChangeC(e){
			console.log(e);
			this.r_applets_id = e
		},
		// 新增侧边栏-频道
		handleChangek(value){
			console.log(value)
			
			if(value == 1){
				this.categoryShowList = this.categoryManList
			}
			else if(value == 2){
				this.categoryShowList = this.categoryWomanList
			}
			else {
				this.categoryShowList = []
			}
			this.x_book_type = value
			this.x_category = undefined // 重置分类内容
		},
		// 新增侧边栏-分类
		handleChangeL(value){
			this.x_category = value
		},
		
		// 搜索
		searchButton(){
			let that = this
			that.search_button_loading = true
			let r_data = {
				limit: that.r_limit,
				page: that.r_page,
				
				applets_id: that.r_applets_id,
				// gzh_id: that.r_gzh_id,
				date_key: that.endTime.replace(/-/g, ''),
			}
			if(that.r_sort_field){
				r_data.order = that.r_sort_field
				r_data.sort = that.r_sort_type
			}
			xcxDataList(r_data).then(res=>{
				console.log("搜索结果",res)
				if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
					that.$message.success('搜索成功');
					that.search_button_loading = false
					that.table_total = res.data.data.total
					that.tableShowData = res.data.data.data
					
				}
				else {
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
				
				// 在打开了ant design的侧边栏组件之后，每次调搜索请求，body身上都会被加上overflow-x: hidden，就会导致横向滚动条失效，所以要按照下面这么搞
				setTimeout(()=>{
					document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
				},100)
				
			}).catch(err=>{
				console.log(err)
				that.$message.error("搜索失败，可能是网络出现问题");
			})
		},
		
		
		// 点击表格表头，筛选排序
		tableThClick(index,status,type){
			let that = this
			console.log(index,status,type);
			if(status == 0){ // 默认
				that.r_sort_field = ""
				that.r_sort_type = ""
			}
			else if(status == 1){ // desc
				that.r_sort_field = type
				that.r_sort_type = "desc"
			}
			else if(status == 2){ // asc
				that.r_sort_field = type
				that.r_sort_type = "asc"
			}
			
			that.searchButton()
		},
		
		// 表格内的编辑
		editTdClick(index){
			let that = this
			// console.log("表格内的编辑",that.tableShowData[index])
			
			bookInfo({id: that.tableShowData[index].put_book_id}).then(res=>{
				console.log(res.data.data)
				let data = res.data.data
				
				if(that.tableShowData[index].book_type == 1){
					this.categoryShowList = this.categoryManList
				}
				else if(that.tableShowData[index].book_type == 2){
					this.categoryShowList = this.categoryWomanList
				}
				else {
					this.categoryShowList = []
				}
				this.drawer_title = "编辑"
				// 直接从表格那数据
				// that.x_book_name = that.tableShowData[index].book_name, // 作品名称
				// that.x_roi = that.tableShowData[index].return_require, // 首日ROI目标(%)
				// that.x_book_type = that.tableShowData[index].book_type.toString(), // 频道
				// that.x_category = that.tableShowData[index].category, // 分类
				// that.x_id = that.tableShowData[index].put_book_id // 表格id
				
				// 从接口拿数据
				that.x_book_name = data.book_name, // 作品名称
				that.x_roi = data.return_require, // 首日ROI目标(%)
				that.x_book_type = data.type.toString(), // 频道
				that.x_category = data.category, // 分类
				that.x_id = data.id // 表格id
				
				that.visible = true
			})
			
			
		},
		
		
		// 分页的页数变化
		paginationChange(e){
			console.log(e)
			this.searchButton()
		},
		
		sortClick(index){ // 点击表头给内容进行排序
			let that = this
			let th_status // 0是默认，1是箭头向下，2是箭头向上
			console.log(that.rableTitle[index].type)
			if(that.rableTitle[index].sort_control){ // 是否有排序功能
				if(index !== this.select_sort_index){
					this.select_sort_index = index
					that.rableTitle.forEach(res=>{
						res.sort_status = 0
					})
					that.rableTitle[index].sort_status = 1
					th_status = 1
				}
				else { // 点击的是同一个表头
					if(that.rableTitle[index].sort_status === 0){
						that.rableTitle[index].sort_status = 1 // 箭头向下
						th_status = 1
					}
					else if(that.rableTitle[index].sort_status === 1){
						that.rableTitle[index].sort_status = 2 // 箭头向上
						th_status = 2
					}
					else if(that.rableTitle[index].sort_status === 2){
						that.rableTitle[index].sort_status = 0
						th_status = 0
					}
				}
				
				
				that.tableThClick(index, th_status, that.rableTitle[index].type)
				// this.$emit('table-th-click', index, th_status, that.rableTitle[index].type)
			}
		},
		editTable(item,type){
			console.log(item);
			if(type == 1){ // 查看使用详情
				this.$router.push({ path:'/xcxSchemeUse',query:{applets_id: item.id}})
			}
			else if(type == 2){ // 查看小程序详情
				this.$router.push({ path:'/xcxOperate',query:{applets_name: item.name}})
			}
		}
	},
	filters: {
		bookTypeFilters(value){
			// console.log("过滤器",value)
			let vvv 
			if(value === 0){
				vvv = "未设置"
			}
			else if(value === 1){
				vvv = "男频"
			}
			else if(value === 2){
				vvv = "女频"
			}
			return vvv
		},
		tableToFixed(value){
			// console.log("过滤器",value)
			let v = Number(value)
			return v.toFixed(2)
		}
	}
}
</script>

<style scoped>

.table-th-cell:hover {
	background-color: #eee;
}
.table-th-cell:hover .table-th-cell-sticky{
	background-color: #eee;
}


</style>